// 09-10 (maqueta aprobada «el aviso del móvil abre el agente»): tocar la notificación de un agente abre SU chat
// en la oficina. El service worker (public/sw.js, `notificationclick`) enfoca la app si ya está abierta y le manda
// OPEN_AGENT; aquí se escucha en toda la app autenticada (también desde /home) y se navega a
// /oficina?agente=<id>. Se contesta por el puerto del mensaje: si nadie contesta (una versión vieja de la app
// abierta), el SW navega la ventana él mismo. Con la app cerrada, el SW la abre ya en esa dirección.
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const MENSAJE_ABRIR_AGENTE = 'OPEN_AGENT';
export const MENSAJE_ABIERTO = 'OPEN_AGENT_OK';

/**
 * A dónde ir para ver el chat de `agentId`. Si ya se está en la oficina, se conservan sus parámetros (p. ej.
 * `?v2=1`) salvo la sala, que taparía el chat; desde cualquier otra pantalla, la oficina limpia.
 */
export function rutaDelAgente(agentId: string, actual: { pathname: string; search: string }): string {
  const params = new URLSearchParams(actual.pathname === '/oficina' ? actual.search : '');
  params.delete('sala');
  params.set('agente', agentId);
  return `/oficina?${params.toString()}`;
}

/** El mensaje del SW, si es «abre este agente»: su id; si no, null. */
export function agenteDelMensaje(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null;
  const { type, agentId } = data as { type?: unknown; agentId?: unknown };
  return type === MENSAJE_ABRIR_AGENTE && typeof agentId === 'string' && agentId ? agentId : null;
}

export function useAbrirDesdeAviso(): void {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator) || !navigator.serviceWorker) return;
    const sw = navigator.serviceWorker;
    const alMensaje = (e: MessageEvent) => {
      const agentId = agenteDelMensaje(e.data);
      if (!agentId) return;
      e.ports[0]?.postMessage({ type: MENSAJE_ABIERTO });
      navigate(rutaDelAgente(agentId, { pathname, search }));
    };
    sw.addEventListener('message', alMensaje);
    return () => sw.removeEventListener('message', alMensaje);
  }, [navigate, pathname, search]);
}
